export const DISABLED_ITEM_TYPE = ["エントリーシート"];
